import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Layout } from 'antd';
import {
  BranchesOutlined,
  PlusOutlined,
  TeamOutlined,
  ToolOutlined,
  DiffOutlined,
  AuditOutlined,
  LineChartOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons';
import { withTranslation } from 'react-i18next';
const { Sider } = Layout;
const { SubMenu } = Menu;

let NAV_ITEMS = [
  {
    title: 'sideBar.roadRepairPlans',
    link: '/list',
    icon: <BranchesOutlined />,
  },
  {
    title: 'sideBar.armGovernmentServices',
    icon: <AuditOutlined />,
    children: [
      {
        title: 'Госуслуги',
        link: '/gosuslugy',
        icon: <AuditOutlined />,
      },
      {
        title: 'sideBar.governmentServicesEducation',
        link: '/gosuslugy-education',
        icon: <AuditOutlined />,
      },
    ],
  },
  {
    title: 'sideBar.addRoadRepairPlan',
    link: '/list/add',
    icon: <PlusOutlined />,
  },
  {
    title: 'sideBar.configuringUsers',
    link: '/users/list',
    icon: <TeamOutlined />,
  },
  {
    title: 'sideBar.settingUpRoles',
    link: '/roles/list',
    icon: <ToolOutlined />,
  },
  {
    title: 'sideBar.settingUpDirectories',
    link: '/catalogs',
    icon: <DiffOutlined />,
  },
  {
    title: 'sideBar.makeSchedule',
    link: '/passenger-transport',
  },
  {
    title: 'sideBar.userActions',
    link: '/user-actions',
  },
  {
    title: 'sideBar.indicators',
    link: '/indicators',
    icon: <LineChartOutlined />,
  },
  {
    title: 'sideBar.cameras',
    link: '/cameras',
    icon: <VideoCameraOutlined />,
  },
];

class SidebarComponent extends Component {
  state = {
    collapsed: true,
  };

  render() {
    let { t, collapsed } = this.props;

    const route = this.props.route.pathname;
    const markActive = (items) =>
      items.forEach((it) => {
        if (it.children) {
          markActive(it.children);
          it.active = it.children.some((child) => child.active);
        } else it.active = it.link === route;
      });
    markActive(NAV_ITEMS);

    const renderItem = (item, key) => (
      <Menu.Item
        key={key}
        className={item.active ? 'ant-menu-item-selected' : ''}
      >
        {item.icon}
        <Link to={item.link} style={{ display: 'initial', color: 'initial' }}>
          {!collapsed && <span>{t(item.title)}</span>}
        </Link>
      </Menu.Item>
    );

    const defaultOpenKeys = NAV_ITEMS.map((item, index) =>
      item.children ? `sub-${index}` : null
    ).filter(Boolean);

    return (
      <Sider
        width={260}
        className="sidebar"
        style={{ background: '#fff', display: collapsed ? 'none' : 'block' }}
        collapsible
        collapsed={collapsed}
      >
        <Menu
          mode="inline"
          defaultOpenKeys={defaultOpenKeys}
          style={{ height: '100%', borderRight: 0 }}
        >
          {NAV_ITEMS.map((item, index) =>
            item.children ? (
              <SubMenu
                key={`sub-${index}`}
                icon={item.icon}
                title={!collapsed && t(item.title)}
              >
                {item.children.map((child, childIndex) =>
                  renderItem(child, `${index}-${childIndex}`)
                )}
              </SubMenu>
            ) : (
              renderItem(item, index)
            )
          )}
        </Menu>
      </Sider>
    );
  }
}
export default withTranslation()(SidebarComponent);
